export default {
  gaCatagory: 'Newsletter_education',
  gaLabel: 'articlelist',
  plateform: 'TOI_',
  NUDGE_SUBSCRIBE_COOKIE: 'educationnlsubscription',
  NUDGE_SUBSCRIBE_API:
    'https://timesofindia.indiatimes.com/newsletter/addsubscription/?frequency=2&scheduletime=1&status=1&nlid=1055&adHoc=true&day=6&hostid=83&id=',
  HEADING: 'The short list in your inbox!',
  TEXT:
    'A weekly decoder of the biggest developments in the education sector delivered to your inbox.',
  RESPONSE_HEADING: 'Thank you for subscribing!',
  RESPONSE_TEXT:
    'Your subscription is confirmed for news related to biggest developments in education sector.',
  EMAIL_INVALID: 'Invalid id. Please enter again',
};
